import { render } from "./ClientesPage.vue?vue&type=template&id=96382296"
import script from "./ClientesPage.vue?vue&type=script&lang=js"
export * from "./ClientesPage.vue?vue&type=script&lang=js"

import "./ClientesPage.vue?vue&type=style&index=0&id=96382296&lang=css"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__